module.exports = __webpack_public_path__ + "media/warten.e7491f06.mp3";